var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.9225 1.7559C19.2479 1.43046 19.2479 0.90283 18.9225 0.577388C18.5971 0.251955 18.0694 0.251955 17.744 0.577388L6.77484 11.5466L2.25584 7.02757C1.9304 6.70215 1.40277 6.70215 1.07733 7.02757C0.751893 7.35299 0.751893 7.88065 1.07733 8.20607L6.18566 13.3144C6.5111 13.6398 7.03874 13.6398 7.36418 13.3144C7.3676 13.311 7.37098 13.3075 7.37433 13.3041L18.9225 1.7559Z"}));
}

Checkmark.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
